import ApiClient from '@/ApiClient';
import { queryOptions, useQueryClient } from '@tanstack/vue-query';

export const getOffCycleConfig = () => {
  return queryOptions({
    queryKey: ['get_one_time_payment_config'],
    queryFn: async () => {
      const result = await ApiClient.getOffCycleConfig();
      return result.data;
    },
  });
};

export const getOffCyclePaymentsByBatchId = batchId => {
  return queryOptions({
    queryKey: ['get_one_time_payment', batchId],
    queryFn: async () => {
      const result = await ApiClient.getOffCyclePaymentBatch(batchId.value);
      return result.data;
    },
  });
};

export const getOffCyclePaymentById = paymentId => {
  return queryOptions({
    queryKey: ['get_off_cyycle_payment_by_id', paymentId],
    queryFn: async () => {
      const result = await ApiClient.getOffCyclePaymentbyId(paymentId.value);
      return result.data;
    },
  });
};

export const getOffCyclePayments = () => {
  return queryOptions({
    queryKey: ['get_one_time_payments'],
    queryFn: async () => {
      const result = await ApiClient.getOffCyclePayments();
      return result.data;
    },
  });
};

export const getOffCycleBatch = batchId => {
  return queryOptions({
    enabled: () => !!batchId.value,
    queryKey: ['get_one_time_payment_batch', batchId],
    queryFn: async () => {
      const result = await ApiClient.getOffCyclePaymentBatch(batchId.value);
      return result.data;
    },
  });
};

export const postSingleOffCyclePayment = () => {
  const queryClient = useQueryClient();

  return {
    mutationFn: async payload => {
      const result = await ApiClient.createOffCycleSinglePayment(payload);
      return result;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries('get_one_time_payments');
    },
  };
};

export const postOffCyclePayment = () => {
  const queryClient = useQueryClient();

  return {
    mutationFn: async payload => {
      const result = await ApiClient.createOffCycleBatch(payload);
      return result;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries('get_one_time_payments');
    },
  };
};

export const saveOffCyclePayment = () => {
  const queryClient = useQueryClient();

  return {
    mutationFn: async ({ payload, batchId }) => {
      const result = await ApiClient.saveOffCycleBatch(batchId, payload);
      return result;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries('get_one_time_payments');
    },
  };
};

export const processOffCyclePayment = () => {
  const queryClient = useQueryClient();

  return {
    mutationFn: async batchId => {
      const result = await ApiClient.processOffCycleBatch(batchId);
      return result;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries('get_one_time_payments');
    },
  };
};

export const deleteOffCycleBatch = () => {
  return {
    mutationFn: async batchId => {
      const result = await ApiClient.deleteOffCycleBatch(batchId);
      return result;
    },
  };
};

export const downloadOffCycleInvoice = () => {
  return {
    mutationFn: async invoiceId => {
      const result = await ApiClient.downloadOffCycleInvoice(invoiceId);
      return result;
    },
  };
};

export const retryOffCyclePayment = () => {
  const queryClient = useQueryClient();

  return {
    mutationFn: async payload => {
      const result = await ApiClient.retryOffCyclePayment(payload);
      return result;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries('get_one_time_payments');
      await queryClient.invalidateQueries('get_one_time_payment');
    },
  };
};

export const hideOffCycleBatch = () => {
  return {
    mutationFn: async batchId => {
      const result = await ApiClient.hideOffCycleBatch(batchId);
      return result;
    },
  };
};

export const getOffCycleInvoices = () => {
  return queryOptions({
    queryKey: ['get_one_time_invoices'],
    queryFn: async () => {
      const result = await ApiClient.getOffCycleInvoices();
      return result.data;
    },
  });
};

export const getDeductionsInvoices = () => {
  return queryOptions({
    queryKey: ['get_deductions_invoices'],
    queryFn: async () => {
      const result = await ApiClient.getDeductionsInvoices();
      return result.data;
    },
  });
};

export const downloadDeductionsInvoice = () => {
  return {
    mutationFn: async invoiceId => ApiClient.downloadDeductionsInvoice(invoiceId),
  };
};

export const downloadDeductionsFile = () => {
  return {
    mutationFn: async invoiceId => ApiClient.downloadDeductionsFile(invoiceId),
  };
};
